import * as React from 'react';
import { useEffect } from 'react';
import { observer } from 'mobx-react';
import styles from './pref_oauth_connections.module.css';
import mcpConnectionsStore from '../../stores/mcp-connections.store';
import { IOAuthConnection } from '../../models/oauth-refresh-token.model';
import IMember from '../../models/member.model';
import Popup, { PopupInfo } from '../common/popup.component';
import trash from '../../img/preferences/trash.svg';
import { getLogger } from '../../services/logger.service';

const log = getLogger('PrefOAuthConnections');

const ConnectionRow = ({ connection }: { connection: IOAuthConnection }) => {
  const onRevoke = () => {
    const info: PopupInfo = {
      title: 'Revoke Access',
      msg: `Revoke access for "${connection.clientName}"? This may take up to an hour to fully take effect.`,
      ok: 'Revoke',
      okCallback: async () => {
        try {
          await mcpConnectionsStore.revoke(connection._id);
        }
        catch (e) {
          log.e('Failed to revoke connection', e);
        }
      },
      cancel: 'Cancel',
    };
    Popup.create(info);
  };

  const member = connection.member as IMember;
  const memberLabel = member?.fullName || member?.email || (connection.member as string);

  return (
    <div className={styles.connectionRow}>
      <div className={styles.connectionName}>{connection.clientName}</div>
      <div className={styles.connectionMember}>{memberLabel}</div>
      <div className={styles.connectionDate}>
        Authorized {new Date(connection.createdAt).toLocaleDateString()}
      </div>
      <img
        alt="revoke"
        className={styles.trash}
        src={trash}
        onClick={onRevoke}
        title="Revoke access"
      />
    </div>
  );
};

const PrefOAuthConnections = observer(() => {
  useEffect(() => {
    mcpConnectionsStore.load();
  }, []);

  const { connections, loading } = mcpConnectionsStore;

  return (
    <div className={styles.component}>
      <div className={styles.title}>OAuth Connections</div>
      <div className={styles.subTitle}>
        AI clients that have been authorized to access your Shipbook account. You can revoke access at any time.
      </div>

      <div className={styles.section}>
        {loading && connections.length === 0 && (
          <div className={styles.loadingText}>Loading...</div>
        )}
        {!loading && connections.length === 0 && (
          <div className={styles.loadingText}>No authorized clients.</div>
        )}
        {connections.map(c => (
          <ConnectionRow key={c._id} connection={c} />
        ))}
      </div>
    </div>
  );
});

export default PrefOAuthConnections;
